import { ElementDetails } from "@/lib/types";
import { GithubIssuesProps } from "./types";

export const details = {
  name: "GithubIssues",
  description: "Displays a list of your Github issues",
  tags: ["Development"],
  category: "Github",
  grid: { default: [3, 3], large: [4, 4] },
  gridNames: { default: "Medium", large: "Large" },
  integrationsUsed: ["github"],
  defaultProps: {
    filters: {},
  },
} as ElementDetails<GithubIssuesProps>;
